/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/prop-types */
import { Container, Flex, Stack, Box } from '@chakra-ui/react';
import themeConfig from '../Config/themeConfig';
import { useLocation } from 'react-router-dom';
import useUserStore from '../Hooks/Zustand/Store';
import AccessDeniedPage from '../Components/Access/AccessDenied';
import HeaderComponent from '../Components/Header/HeaderComponents';
import SidebarComponentV3 from '../Components/Sidebar/SidebarComponentV3';


function Layout({ children }) {
  const location = useLocation();
  const globalState = useUserStore();

  const checkAccess = (pathname, access) => {
    if (access?.length === 0) return false;
    const filtered = access?.filter((x) => pathname?.includes(x?.path));
    let rule;
    if (filtered?.length === 0) return true;
    if (filtered?.length === 1) rule = filtered[0];
    else if (filtered?.length > 1)
      rule = filtered.reduce((a, b) => {
        return a?.path?.length > b?.path?.length ? a : b;
      });
    if (rule?.action?.length === 0) return false;
    else return true;
  };

  const company = globalState?.companies?.find((x) => x?.id === globalState?.currentCompany);
  const isAllowed = company?.owner?.includes(globalState?.uid) 
    ? true 
    : checkAccess(location?.pathname, globalState?.access);

  const isFunnelEditPage = location.pathname.includes('/lp-builder');

  return (
    <>
      <Flex height="100vh" w={'full'}>
        {!isFunnelEditPage && (
          <SidebarComponentV3 layout={themeConfig.layout} />
        )}

        {isAllowed ? (
          <Container maxW={'full'} overflowY={'scroll'} position='relative'>
            <HeaderComponent layout={themeConfig.layout} />
            
            <Stack>
              {children}
            </Stack>
          </Container>
        ) : (
          <Box w='full' h='100vh' overflowY='auto'>
            <AccessDeniedPage />
          </Box>
        )}
      </Flex>
    </>
  );
}

export default Layout;